module.exports = __webpack_public_path__ + "static/media/5-stars.cbbbade7.svg";